import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useSelector } from "react-redux";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
function HospClinicDetail() {
  const { state } = useLocation();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [hospClinicDetails, setHospClinicDetails] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const pageSlice = useSelector((state) => state.pageSlice.pageSlice);
  const navigate = useNavigate();
  const activeTab = state?.activeTab;

  const fetchHospClinicDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-hospital/${id}`
      );
      setHospClinicDetails(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching hospital/clinic details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHospClinicDetails();
  }, [id]);

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const handleStatusChange = async (status) => {
    if (status === "approved") {
      setIsApproving(true);
    } else {
      setIsRejecting(true);
    }

    try {
      const response = await client.put(
        `/admin/profile/change-status/${id}`,
        null,
        {
          params: { status },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || `Request ${status} successfully`
        );
        fetchHospClinicDetails();
        navigate(-1);
      } else {
        toast.error(response.data.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      toast.error(`Failed to ${status} request`);
    } finally {
      if (status === "approved") {
        setIsApproving(false);
      } else {
        setIsRejecting(false);
      }
    }
  };

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() =>
                    navigate(-1, { state: { activeTab: activeTab } })
                  }
                />
                <span>Requests</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img
                          src={hospClinicDetails?.information?.image}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div className="">
                          <h2>
                            {hospClinicDetails?.user?.firstName}{" "}
                            {hospClinicDetails?.user?.lastName}
                          </h2>
                          <p>
                            <span>Request ID:</span>{" "}
                            {hospClinicDetails?.profileId}
                          </p>
                        </div>
                        {pageSlice === "request" && activeTab === "Pending" && (
                          <div className="reject-approve-btn">
                            <button
                              className="reject-btn"
                              onClick={() => handleStatusChange("rejected")}
                              disabled={isRejecting || isApproving}
                            >
                              {isRejecting ? "Processing..." : "Reject"}
                            </button>
                            <button
                              className="approve-btn"
                              onClick={() => handleStatusChange("approved")}
                              disabled={isApproving || isRejecting}
                            >
                              {isApproving ? "Processing..." : "Approve"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Type"
                            value={formatRole(
                              hospClinicDetails?.facilityOrProfession
                            )}
                            readOnly
                          />
                        </div>

                        <div class="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(hospClinicDetails?.role)}
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              hospClinicDetails?.user?.phoneNumber?.number
                                ? `+${hospClinicDetails?.user?.phoneNumber?.dialCode} ${hospClinicDetails?.user?.phoneNumber?.number}`
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={hospClinicDetails?.user?.email}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={hospClinicDetails?.information?.address?.add}
                            readOnly
                          />
                        </div>
                        <div class="input-field"></div>
                      </div>
                      <div className="input-group">
                        {hospClinicDetails?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                hospClinicDetails?.information?.additionalText
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {hospClinicDetails?.specializations && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Specializations</label>
                            <textarea
                              placeholder="Specializations"
                              value={hospClinicDetails?.specializations?.join(
                                ", "
                              )}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="request-document">
                <h4>Other Services</h4>
                <div className="other-services-container">
                  {hospClinicDetails?.otherServices?.map((service, index) => (
                    <div className="service-card" key={index}>
                      {service}
                    </div>
                  ))}
                </div>
              </div>
              <div className="request-document-other">
                <h4>Insurances</h4>
                <div className="other-services-container">
                  {hospClinicDetails?.insurances?.map((item, index) => (
                    <div className="service-card" key={index}>
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* <div className="request-document-other">
                <h4>Doctors</h4>
                <div className="other-services-container">
                  {hospClinicDetails?.doctor?.map((doc, index) => (
                    <div className="service-card" key={index}>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#d58de8",
                          fontWeight: "500",
                        }}
                      >
                        {doc.speciality}
                      </div>
                      <div
                        style={{
                          fontWeight: "600",
                          marginTop: "4px",
                          fontSize: "20.98px",
                        }}
                      >
                        {doc.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div> */}
              {hospClinicDetails?.doctor && (
                <div className="request-document-other">
                  <h4>Doctors</h4>
                  <div className="other-services-container doctors-list-data">
                    {hospClinicDetails?.doctor?.map((doc, index) => (
                      <div className="service-card" key={index}>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#d58de8",
                            fontWeight: "500",
                          }}
                        >
                          {doc.speciality}
                        </div>
                        <div
                          className="second"
                          style={{
                            fontWeight: "600",
                            marginTop: "4px",
                            fontSize: "20.98px",
                          }}
                        >
                          {doc.name}
                        </div>
                        {doc?.schedule && doc.schedule.length > 0 && (
                          <div
                            className="doctors-details"
                            style={{ marginTop: "12px" }}
                          >
                            <h5
                              style={{ fontSize: "16px", marginBottom: "6px" }}
                            >
                              Schedule
                            </h5>
                            <div className="doc-main">
                              <div
                                className="doc d-flex justify-content-between py-0"
                                style={{ width: "100%" }}
                              >
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Time</th>
                                      <th>Days Available</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {doc.schedule.map((slot, sIndex) => (
                                      <tr key={sIndex}>
                                        <td>
                                          {slot?.startTime} - {slot?.endTime}
                                        </td>
                                        <td>{slot?.days?.join(", ")}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {hospClinicDetails?.documents && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      {hospClinicDetails?.documents?.certificate && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospClinicDetails?.documents?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospClinicDetails?.documents?.certificate}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {hospClinicDetails?.documents &&
                              Object.keys(hospClinicDetails.documents).length >
                                0
                                ? Object.keys(hospClinicDetails.documents)[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {hospClinicDetails?.documents?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospClinicDetails?.documents?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospClinicDetails?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {hospClinicDetails?.documents &&
                              Object.keys(hospClinicDetails.documents).length >
                                1
                                ? Object.keys(hospClinicDetails.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {hospClinicDetails?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {hospClinicDetails?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospClinicDetails?.personalDocuments?.nimc
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospClinicDetails?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {hospClinicDetails?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospClinicDetails?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={
                                hospClinicDetails?.personalDocuments?.license
                              }
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
}

export default HospClinicDetail;
